import { Stack, VStack } from "@chakra-ui/react";
import { InputField } from "../../../../components/fields/InputField";
import LayoutTypeSelector from "../LayoutTypeSelector";

const ParagraphLayout = ({ questionIndex, onChange }) => {
  return (
    <VStack w={"100%"} spacing={6}>
      <Stack
        w={"100%"}
        gap={4}
        spacing={0}
        flexDirection={{ base: "column", md: "row" }}
      >
        <InputField
          field={{
            id: `prompt`,
            placeholder: "Add a paragraph",
            validation: {
              required: { value: true, message: "Paragraph is required" },
            },
          }}
          multiLine={true}
        />
        <LayoutTypeSelector questionIndex={questionIndex} onChange={onChange} />
      </Stack>
    </VStack>
  );
};

export default ParagraphLayout;
